/* ============================================
   Global JavaScript
   ============================================ */

// Shopify formatMoney helper
if (typeof Shopify === 'undefined') {
  var Shopify = {};
}

Shopify.formatMoney = function(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Cart AJAX functionality
Shopify.onCartUpdate = function(cart, options) {
  options = options || {};

  // Update cart count in header
  const cartCountElements = document.querySelectorAll('[data-cart-count]');
  cartCountElements.forEach(el => {
    el.textContent = cart.item_count;
    if (cart.item_count > 0) {
      el.classList.add('has-items');
    } else {
      el.classList.remove('has-items');
    }
  });

  const moneyFormat = window.themeMoneyFormat || Shopify.money_format || '${{amount}}';
  const cartTotalElements = document.querySelectorAll('[data-cart-total]');
  cartTotalElements.forEach(el => {
    el.textContent = Shopify.formatMoney(cart.total_price, moneyFormat);
  });
  
  if (Shopify.cartAwareCards) {
    Shopify.cartAwareCards.sync(cart);
  }

  // Open cart drawer after a new item is added, but not while adjusting a card quantity.
  if (options.openDrawer !== false && typeof window.openCartDrawer === 'function') {
    window.openCartDrawer(cart);
  } else if (typeof window.refreshCartDrawer === 'function') {
    window.refreshCartDrawer(cart);
  }
};

// Keep product-card actions in sync with the cart.
Shopify.cartAwareCards = (function() {
  const formSelector = [
    '.amzn-card__form[data-product-form]',
    '.product-card__form[data-product-form]',
    '.product-card-carousel__form[data-product-form]',
    '.deal-product-card__form[data-product-form]',
    '.product-main-buy__form[data-product-form]',
    '.product-main__form[data-product-form]'
  ].join(',');

  const quantityControlsSelector = [
    '.product-main-buy__form[data-product-form]',
    '.product-main__form[data-product-form]'
  ].join(',');

  let currentCart = null;
  const pnfBogoVariantIds = new Set(
    (Array.isArray(window.pnfBogoVariantIds) ? window.pnfBogoVariantIds : []).map(String)
  );

  function matches(form) {
    return form && form.matches(formSelector);
  }

  function getVariantId(form) {
    const input = form.querySelector('[name="id"]');
    return input ? String(input.value) : '';
  }

  function isPnfBogoForm(form) {
    return Boolean(form) && pnfBogoVariantIds.has(getVariantId(form));
  }

  function getCartItem(form) {
    if (!currentCart || !Array.isArray(currentCart.items)) return null;
    const variantId = getVariantId(form);
    const matchingItems = currentCart.items.filter(item => String(item.variant_id) === variantId);
    if (!matchingItems.length) return null;
    if (!isPnfBogoForm(form)) return matchingItems[0];

    return Object.assign({}, matchingItems[0], {
      quantity: matchingItems.reduce((total, item) => total + Number(item.quantity || 0), 0)
    });
  }

  function usesQuantityControls(form) {
    return form && form.matches(quantityControlsSelector);
  }

  function getMaximumQuantity(form) {
    const quantityInput = form.querySelector('input[name="quantity"]');
    if (!quantityInput || !quantityInput.hasAttribute('max')) return null;

    const maximum = Number(quantityInput.getAttribute('max'));
    return Number.isSafeInteger(maximum) && maximum >= 0 ? maximum : null;
  }

  function isSoldOut(form) {
    return form.dataset.productSoldOut === 'true' || getMaximumQuantity(form) === 0;
  }

  function preparePnfBogoForm(form) {
    if (!isPnfBogoForm(form)) {
      delete form.dataset.pnfBogo;
      return false;
    }

    form.dataset.pnfBogo = 'true';
    let quantityInput = form.querySelector('input[name="quantity"]');
    const submitButton = form.querySelector('[type="submit"]');

    if (!quantityInput && submitButton) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      form.insertBefore(quantityInput, submitButton);
    }

    if (quantityInput) {
      const maximum = getMaximumQuantity(form);
      if (maximum === null || maximum >= 2) {
        quantityInput.value = '2';
        quantityInput.min = '2';
        quantityInput.step = '2';
      }
    }

    return true;
  }

  function syncQuantityButtons(form, quantity) {
    const decreaseButton = form.querySelector('[data-card-quantity-change="-1"]');
    const increaseButton = form.querySelector('[data-card-quantity-change="1"]');
    const maximum = getMaximumQuantity(form);

    if (decreaseButton) decreaseButton.disabled = quantity < 1;
    if (increaseButton) {
      increaseButton.disabled = maximum !== null && quantity >= maximum;
      if (increaseButton.disabled) {
        increaseButton.setAttribute('title', 'Maximum available quantity reached');
      } else {
        increaseButton.removeAttribute('title');
      }
    }
  }

  function ensureControls(form) {
    const isPnfBogo = preparePnfBogoForm(form);
    if (!usesQuantityControls(form) || isPnfBogo) {
      const existingControls = form.querySelector('[data-card-quantity]');
      if (existingControls) existingControls.remove();
      form.classList.remove('is-cart-aware');
      return;
    }

    if (form.querySelector('[data-card-quantity]')) return;

    const submitButton = form.querySelector('[type="submit"]');
    if (!submitButton || submitButton.disabled) return;

    form.classList.add('is-cart-aware');

    let quantityInput = form.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '1';
      form.insertBefore(quantityInput, submitButton);
    }

    const controls = document.createElement('div');
    controls.className = 'card-cart-quantity';
    controls.dataset.cardQuantity = '';
    controls.hidden = true;
    controls.innerHTML =
      '<button type="button" class="card-cart-quantity__button" data-card-quantity-change="-1" aria-label="Decrease quantity">&minus;</button>' +
      '<span class="card-cart-quantity__value" data-card-quantity-value aria-live="polite">1</span>' +
      '<button type="button" class="card-cart-quantity__button" data-card-quantity-change="1" aria-label="Increase quantity">+</button>';
    form.insertBefore(controls, submitButton);
  }

  function syncForm(form) {
    ensureControls(form);

    const isPnfBogo = isPnfBogoForm(form);
    const hasQuantityControls = usesQuantityControls(form) && !isPnfBogo;
    const controls = form.querySelector('[data-card-quantity]');
    const value = form.querySelector('[data-card-quantity-value]');
    const quantityInput = form.querySelector('input[name="quantity"]');
    const submitButton = form.querySelector('[type="submit"]');
    const submitText = submitButton && (submitButton.querySelector('span') || submitButton);
    if (!submitButton || !submitText) return;

    const maximum = getMaximumQuantity(form);
    if (isSoldOut(form) || (isPnfBogo && maximum !== null && maximum < 2)) {
      form.dataset.cartState = 'sold-out';
      if (controls) controls.hidden = true;
      submitText.textContent = isPnfBogo && maximum === 1
        ? 'Only 1 available'
        : (form.dataset.soldOutLabel || 'Out of stock');
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
      return;
    }

    submitButton.removeAttribute('aria-disabled');

    const item = getCartItem(form);
    if (item && item.quantity > 0) {
      form.dataset.cartState = isPnfBogo ? 'bogo-added' : 'added';
      if (controls) controls.hidden = isPnfBogo;
      if (value) value.textContent = item.quantity;
      if (quantityInput && hasQuantityControls) quantityInput.value = item.quantity;
      if (quantityInput && isPnfBogo) quantityInput.value = '2';
      if (hasQuantityControls) syncQuantityButtons(form, item.quantity);
      submitText.textContent = isPnfBogo ? 'Add Another BOGO Pair' : 'Add to Cart';
      submitButton.disabled = false;
      submitButton.setAttribute('aria-label', isPnfBogo ? 'Add another BOGO pair' : 'Add to cart');
    } else {
      form.dataset.cartState = 'empty';
      if (controls) controls.hidden = true;
      if (value) value.textContent = isPnfBogo ? '2' : '1';
      if (quantityInput && hasQuantityControls) quantityInput.value = '1';
      if (quantityInput && isPnfBogo) quantityInput.value = '2';
      if (hasQuantityControls) syncQuantityButtons(form, 0);
      submitText.textContent = isPnfBogo ? 'Add BOGO Pair' : 'Add to Cart';
      submitButton.disabled = false;
      submitButton.setAttribute('aria-label', isPnfBogo ? 'Add BOGO pair, two for the price of one' : 'Add to cart');
    }
  }

  function sync(cart) {
    currentCart = cart;
    document.querySelectorAll(formSelector).forEach(syncForm);
  }

  async function changeQuantity(form, delta) {
    const item = getCartItem(form);
    if (!item || !Number.isInteger(delta) || Math.abs(delta) !== 1) return;

    const currentQuantity = Number(item.quantity);
    if (!Number.isSafeInteger(currentQuantity) || currentQuantity < 1) return;
    const nextQuantity = Math.max(0, currentQuantity + delta);
    const maximum = getMaximumQuantity(form);
    if (maximum !== null && nextQuantity > maximum) {
      syncQuantityButtons(form, currentQuantity);
      return;
    }

    const buttons = form.querySelectorAll('[data-card-quantity-change]');
    buttons.forEach(button => { button.disabled = true; });

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: String(item.key), quantity: nextQuantity })
      });
      if (!response.ok) throw new Error('Status ' + response.status);
      const cart = await response.json();
      Shopify.onCartUpdate(cart, { openDrawer: false });
    } catch (error) {
      console.error('Cart quantity update error:', error);
    } finally {
      buttons.forEach(button => { button.disabled = false; });
      if (currentCart) syncForm(form);
    }
  }

  function init() {
    document.querySelectorAll(formSelector).forEach(ensureControls);

    document.addEventListener('click', function(event) {
      const button = event.target.closest('[data-card-quantity-change]');
      if (!button) return;
      const form = button.closest(formSelector);
      if (!form) return;
      changeQuantity(form, Number(button.dataset.cardQuantityChange));
    });

    document.addEventListener('change', function(event) {
      if (!event.target.matches('[name="id"]')) return;
      const form = event.target.closest(formSelector);
      if (form && currentCart) syncForm(form);
    });

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return;

          const addedForms = [];
          if (node.matches(formSelector)) addedForms.push(node);
          node.querySelectorAll(formSelector).forEach(function(form) {
            addedForms.push(form);
          });

          addedForms.forEach(function(form) {
            ensureControls(form);
            if (currentCart) syncForm(form);
          });
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(response => response.json())
      .then(sync)
      .catch(error => console.error('Cart state error:', error));
  }

  return { init, matches, sync, isPnfBogoForm };
})();

function pnfRunWhenIdle(callback) {
  const isDesktopViewport = window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
  const fallbackDelay = isDesktopViewport ? 1500 : 500;
  const idleTimeout = isDesktopViewport ? 3500 : 2000;

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout: idleTimeout });
    return;
  }

  window.setTimeout(callback, fallbackDelay);
}

// Add to cart AJAX for product forms
document.addEventListener('DOMContentLoaded', function() {
  pnfRunWhenIdle(function() {
    Shopify.cartAwareCards.init();
  });

  // Product form AJAX (delegated to catch dynamically rendered forms)
  document.addEventListener('submit', function(e) {
    if (e.defaultPrevented) return;
    const form = e.target.closest('[data-product-form]');
    if (!form) return;

    const formSubmitButton = form.querySelector('[type="submit"]');
    if (!formSubmitButton || form.dataset.cartSubmitting === 'true' || form.dataset.productSoldOut === 'true' || formSubmitButton.disabled) {
      e.preventDefault();
      return;
    }

    const isPnfBogo = Shopify.cartAwareCards.isPnfBogoForm(form);
    // Allow explicit checkout submissions to submit normally.
    const submitter = e.submitter;
    if (submitter) {
      if (submitter.name === 'checkout') {
        return;
      }
    }

    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (!submitBtn) return;
    const submitText = submitBtn.querySelector('span') || submitBtn;
    const originalText = submitText.textContent;

    const variantInput = form.querySelector('[name="id"]');
    let quantityInput = form.querySelector('[name="quantity"]');
    const variantId = variantInput ? String(variantInput.value).trim() : '';
    const requestedQuantity = isPnfBogo ? 2 : (quantityInput ? Number(quantityInput.value) : 1);

    if (!/^\d+$/.test(variantId) || !Number.isSafeInteger(requestedQuantity) || requestedQuantity < 1 || requestedQuantity > 99) {
      if (quantityInput) {
        quantityInput.value = '1';
        quantityInput.setCustomValidity('Enter a whole-number quantity from 1 to 99.');
        quantityInput.reportValidity();
        quantityInput.setCustomValidity('');
      }
      return;
    }

    if (isPnfBogo) {
      if (!quantityInput) {
        quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'quantity';
        form.appendChild(quantityInput);
      }
      quantityInput.value = '2';
    }

    submitBtn.disabled = true;
    form.dataset.cartSubmitting = 'true';
    submitText.textContent = 'Adding...';
    let errorMessage = form.querySelector('[data-cart-add-error]');
    if (errorMessage) errorMessage.hidden = true;
    let itemAdded = false;

    const formData = new FormData(form);
    if (isPnfBogo) formData.set('quantity', '2');

    const addUrl = new URL(form.action, window.location.origin);
    addUrl.pathname = addUrl.pathname.replace(/\/$/, '').replace(/(?:\.js)?$/, '.js');
    fetch(addUrl.href, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
    .then(async response => {
      const result = await response.json();
      if (!response.ok) {
        const failure = new Error('Cart add failed');
        failure.cartMessage = typeof result.description === 'string' ? result.description : '';
        throw failure;
      }
      itemAdded = true;
      return result;
    })
    .then(data => {
      return fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    })
    .then(response => {
      if (!response.ok) throw new Error('');
      return response.json();
    })
    .then(cart => {
      const isCartAware = Shopify.cartAwareCards.matches(form);
      Shopify.onCartUpdate(cart, { openDrawer: true });
      if (isCartAware) {
        submitBtn.disabled = false;
      } else {
        submitText.textContent = 'Added!';

        setTimeout(() => {
          submitBtn.disabled = false;
          submitText.textContent = originalText;
        }, 2000);
      }
    })
    .catch(error => {
      console.error('Add to cart error:', error);
      submitBtn.disabled = false;
      submitText.textContent = originalText;
      if (itemAdded) {
        window.openCartDrawer?.();
        return;
      }
      if (!errorMessage) {
        errorMessage = document.createElement('p');
        errorMessage.dataset.cartAddError = '';
        errorMessage.setAttribute('role', 'alert');
        form.appendChild(errorMessage);
      }
      errorMessage.textContent = error.cartMessage || document.querySelector('script[data-cart-add-error]')?.dataset.cartAddError;
      errorMessage.hidden = false;
    })
    .finally(() => {
      delete form.dataset.cartSubmitting;
    });
  });
  
  // Accordion functionality
  document.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
    trigger.addEventListener('click', function() {
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('is-open');
      
      // Close all other items
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('is-open'));
      
      // Toggle current item
      if (!isOpen) {
        item.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      } else {
        this.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // Deal countdowns
  const countdownElements = Array.from(document.querySelectorAll('[data-deal-end]'));
  if (countdownElements.length) {
    const updateCountdowns = () => {
      const now = new Date().getTime();
      countdownElements.forEach((el) => {
        const end = new Date(el.dataset.dealEnd).getTime();
        if (Number.isNaN(end)) return;
        const diff = Math.max(end - now, 0);
        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        el.textContent = `Ends in ${days} days ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      });
    };

    updateCountdowns();
    setInterval(updateCountdowns, 1000);
  }
});

// Cart drawer functions (can be overridden by cart-drawer.liquid)
window.openCartDrawer = window.openCartDrawer || function() {
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
};

window.closeCartDrawer = window.closeCartDrawer || function() {
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }
};
